// removed by extract-text-webpack-plugin
module.exports = {"container":"_5NTGuFHoQ0jnO77qcoyFK"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/UnauthLayout.css
// module id = 1047
// module chunks = 0